/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import React, { Suspense, useEffect, useRef, useState } from "react";

import { connect } from "react-redux";

// react-router components


import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

// @mui material components
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import { ThemeProvider } from "@mui/material/styles";

// Dashboard components
import MDBox from "./components/MDBox";

// Dashboard example components
import Configurator from "./examples/Configurator";
import Sidenav from "./examples/Sidenav";

// Dashboard themes
import theme from "./assets/theme";

// Dashboard Dark Mode themes
import themeDark from "./assets/theme-dark";

// Dashboard contexts
import {
  setMiniSidenav,
  setOpenConfigurator,
  useMaterialUIController,
} from "./context";

import IdleTimerContainer from "utils/IdleTimerContainer";

// JWT and Cookies
import { isExpired } from "react-jwt";
import Cookies from "universal-cookie";

import { getSubModulesByRoleId } from "../src/store";

// Dashboard layouts (includes sub route components)
import Activity from "layouts/activity";
import AssetMaster from "layouts/ASTMSTW";
import BinPalletMasters from "layouts/bin-pallet-masters";
import DashboardForm from "layouts/dashboard-form";
import GrnDetails from "layouts/grn-details";
import Home from "layouts/home";
import ItemMasterParent from "layouts/item-master/index";
import Otp from "layouts/otp";
import Picklist from "layouts/picklist";
import PrinterConfigurator from "layouts/printer-configurator";
import ProductionPlan from "layouts/production-plan";
import RelationLocation from "layouts/relation-Location";
import UserManagement from "layouts/user-management";
import ViewLocation from "layouts/view-location";
import Warehouses from "layouts/warehouses";
import ForgotPassword from "./layouts/authentication/forgot-password";
import Login from "./layouts/authentication/login";
import Logout from "./layouts/authentication/logout";
import ResetPassword from "./layouts/authentication/reset-password";
import SetPassword from "./layouts/authentication/set-password";
import Profile from "./layouts/profile";

import AcceptPo from "layouts/accept-po";
import CategoryCreationParent from "layouts/category-creation";
import CategoryItemMapping from "layouts/category-item-mapping";
import DeliveryWarehouse from "layouts/delivery-warehouse-new";
import FgWarehouse from "layouts/fg-warehouse-new";
import LocationMapping from "layouts/location-mapping";
import OCR from "layouts/ocr";
import RegisteredVendors from "layouts/registered-vendors";
import RejectedVendors from "layouts/rejected-vendors";
import ReprintParent from "layouts/reprint-new/index";
import Status from "layouts/status";
import TransferOrder from "layouts/transfer-order/index";
import VendorDetails from "layouts/vendor-details";
import Warehouse from "layouts/warehouse-new";

import AsnDetails from "layouts/asn-details";
import AssemblyMaster from "layouts/assembly-master";
import AssemblyView from "layouts/assembly-view";
import NoAccessPage from "layouts/authentication/no-access-page";
import BannerLogo from "layouts/banner-logo";
import Bom from "layouts/bom";
import Dispatch from "layouts/dispatch";
import FgMaster from "layouts/fg-master";
import FinishedGoodsParent from "layouts/finished-goods-parent";
import Quarantine from "layouts/quarantine";
import Rejections from "layouts/rejections";
import AgeingReport from "layouts/reports/ageing-report";
import DocumentTypeTurnAroundTime from "layouts/reports/document-type-turn-around-time";
import ItemStatus from "layouts/reports/item-status";
import PicklistAgeing from "layouts/reports/picklist-ageing";
import WarehouseOccupancy from "layouts/reports/warehouse-occupancy";
import WmsStock from "layouts/reports/wms-stock";
import SfWarehouse from "layouts/sf-warehouse";
import StandardVendorForm from "layouts/standard-vendor-form";
import StationAndItemMapping from "layouts/station-and-item-mapping";
import TransactionParent from "layouts/transaction-parent";
import UnplannedIssue from "layouts/unplanned-issue";
import WorkOrder from "layouts/work-order";

import VendorMaterialMappingMaster from "layouts/vendor-material-mapping-master";

// import PurchaseOrders from "layouts/purchase-orders";
import Invoice from "layouts/invoice";
import PurchaseOrders from "layouts/purchase-order-new";

import NewAdminManagement from "layouts/admin-management";
import Calendar from "layouts/calendar";
import DoctypeUserMapping from "layouts/doctype-user-mapping";
import ModuleSubmoduleManagement from "layouts/module-management";
import AsnGrnDependency from "layouts/reports/asn-grn-dependency";
import BomReport from "layouts/reports/bom";
import Consumption from "layouts/reports/consumption";
import FgRelatedReport from "layouts/reports/fg-related-report";
import MinMaxFailure from "layouts/reports/min-max-failure";
import StockAvailability from "layouts/reports/stock-availability";
import Top10 from "layouts/reports/top-10";
import VendorPerformance from "layouts/reports/vendor-performance";

import AiAgent from "layouts/ai-agent";
import AiChatBot from "layouts/ai-chat-bot";
import Registration from "layouts/authentication/registration";
import Circular from "layouts/circular-parent";
import DbbSystemParent from "layouts/dbbSystemParent";
import DocumentDownloadCenter from "layouts/document-download-center";
import DppLayout from "layouts/dpp";
import WarehouseDetailsPage from "layouts/home-cards/warehouseDetails";
import MachineCenter from "layouts/machine-center";
import NewDemand from "layouts/new-demand";
import OperationMachineMap from "layouts/operation-machine-map";
import Operations from "layouts/operations";
import PackagingWorkflowManagement from "layouts/packaging-workflow-management";
import CheckoutPage from "layouts/payment/checkout";
import PaymentPlans from "layouts/payment/index";
import PoManagement from "layouts/po-management";
import ProductionPlanParent from "layouts/production-plan";
import PurchaseOrder from "layouts/purchase-orders/index";
import GrnReport from "layouts/reports/grn-report";
import PicklistTracking from "layouts/reports/picklist-tracking";
import QuarantineReport from "layouts/reports/quarantine-report";
import RejectionReport from "layouts/reports/rejection-report";
import ResourceGroupScreen from "layouts/resource-group-screen";
import UserMachine from "layouts/userMachine";
import VendorMaster from "layouts/vendor-master";
import VendorUpload from "layouts/vendor-upload";

import Manufacturer from "layouts/manufacturer";
import WoProcessLog from "layouts/reports/wo-process-log";
import SupplierInformation from "layouts/Supplier-Information";
import IndustryMaster from "layouts/Industry-master";
import UploadErrorLog from "layouts/uploadErrorLog";
import aiIcon from "../src/assets/chatbot.png";
// import aiIcon from "../src/assets/chatbot2.png";

const cookies = new Cookies();

const App = ({ getSubModulesByRoleId, getSubModulesByRoleIdReducer }) => {
  // console.log = () => {};
  console.warn = () => { };
  console.debug = () => { };
  console.info = () => { };
  console.error = () => { };

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  // Login details from cookies
  let loginDetails = cookies.get("loginDetailsForWMS");

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const location = useLocation();
  const navigate = useNavigate();

  // Change the openConfigurator state
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  const configsButton = (
    <MDBox
      // display="flex"
      display="none"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      // bgColor="white"
      // shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
    // color="dark"
    // sx={{ cursor: "pointer" }}
    // onClick={handleConfiguratorOpen}
    >
      {/* <Icon fontSize="small" color="inherit">
        settings
      </Icon> */}
    </MDBox>
  );

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails ? loginDetails.data.roleId : "";

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  let loading = getSubModulesByRoleIdReducer.loading;

  let warehousesModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "e41cbacf-ca1d-4d92-b980-491d8928cd9a",
    )
    : "";

  let grnDetailsModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "7ce93f23-45db-46dd-81fa-ce66954c0fba",
    )
    : "";

  let reprintModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "cb6cabe4-7621-4a3d-8be6-6d43e87befc4",
    )
    : "";

  let materialIssuanceModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "511218db-be4c-44d2-896d-4c832b2d3f6b",
    )
    : "";

  let storeIssuanceModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "4d1bbe7e-e752-48e3-986f-b2ae4745d405",
    )
    : "";

  let pivTrackingModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "60e34942-b6a2-4615-8f0e-f9674fe8d98f",
    )
    : "";

  let pivFillingAndReleasedPivModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "c53dae9d-3fee-4132-92f8-0d17deef918b",
    )
    : "";

  let productionAllocationModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "d8326dc9-1fda-4a5f-aac0-aa17cf8b28a8",
    )
    : "";

  let userManagementModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "a482ffd0-bc1d-41f9-84ee-cc0d32c85cc7",
    )
    : "";

  let activityMappingModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "6557362e-6abb-4b21-a41b-8f9575d1080a",
    )
    : "";

  let purchaseOrderModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "aa9e3207-b8aa-4164-a130-a9f153a71259",
    )
    : "";

  let aiChatBotModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "c00bee27-4bf5-434a-8e2e-6c5748520f34",
    )
    : "";

  let invoiceModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "fc307411-4c64-4a1a-a588-4fc5f3be076d",
    )
    : "";
  // let purchaseOrderModule = true;

  let purchaseOrderOldModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.moduleId == "298a8399-a170-4ece-8cf6-894627990ece",
    )
    : "";

  let picklistTrackingModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "7abbd2e9-f4c2-4dc7-978d-a057356c0a9e",
    )
    : "";
  let locationMappingModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "fcbb2c82-bbb1-4089-93f5-59ab7b4e3324",
    )
    : "";

  let binMasterModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "e92885b3-7efd-48c7-8d73-597a041980d5",
    )
    : "";
  let itemMasterModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "55f0be2e-e2be-4f7e-b550-912edc656981",
    )
    : "";
  let activityMovementModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "224d6255-982a-45cb-b46e-ca279c422c7c",
    )
    : "";
  let newDemandModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "982fdd5d-b07e-4257-8800-5dba6ccd5143",
    )
    : "";
  let newVendorRequest = modulesData.find(
    (moduleId) => moduleId.moduleId == "1a4c3450-da79-442c-bd38-5a526a60613d",
  );
  let statusModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "ad6289a6-415c-4df0-94c3-66a64b1c08a8",
  );

  let vendorMasterModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "85af413b-b88b-411c-850c-0d7dfd9bd901",
  );

  let vendorMaterialMappingModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "ef4b7b33-3870-4196-8a2d-3f7f35d1ed38",
  );

  let registerVModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "79824fc4-428b-4f0d-8462-9bb103f73afd",
  );

  let rejectedVendorsModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "a203bc3d-29d5-4f57-a822-bed2846c0243",
  );

  let downloadCenterModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "686c6c29-4e07-49cc-a442-0e6070961974",
  );

  let demandModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "f4e71fdd-d9ea-4bb8-85d6-3fc95cf3c069",
  );

  let acceptPOModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "24fda407-d02d-48d9-b019-7d6fa2edc708",
  );

  let productionPlanModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "0cf23241-8bdd-484e-bbbf-0467fed33484",
  );

  let vendorStockModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "df88a80b-4ff4-4f20-a389-ded743489af9",
  );

  let relationLocationModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "5efc6bc9-e593-4add-afd5-912d9f713782",
    )
    : "";

  let reprintNewModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "2e314720-3978-4fa4-ba13-f902bc38ae3b",
  );

  let dppModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "d850b214-450e-42b4-b0a4-4077c8ea2ac8",
    )
    : "";

  let dppClientModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "d850b214-450e-42b4-b0a4-4077c8ea2ac8",
    )
    : "";

  let assetMasterModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "0e59ede8-5448-491d-9d59-ab92bbd94fbe",
  );

  let categoryCreationModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "b76e5f78-9868-4701-b4b9-ab141d9b6f52",
  );
  // let relationLocationModule = modulesData
  //   ? modulesData.find(
  //       (moduleId) =>
  //         moduleId.parentModuleId == "5efc6bc9-e593-4add-afd5-912d9f713782"
  //     )
  //   : "";
  let categoryItemModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "f2abdf3d-1ec6-48f7-b7d2-5722c15ae814",
  );

  let transferOrderModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "427fab5b-22d3-439d-a8a1-aaf03a1cfdf0",
  );

  let docTypeUserMappingModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "026e05cf-44e6-416b-93df-0a085f9f6cf0",
  );

  let quarantineModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "7c758176-8bf7-46ae-bcf5-0789cc05f29e",
  );
  let dispatchModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "148e92fb-cb61-4da0-937b-51f9e4a1171a",
  );

  let transactionModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "bba44c22-7961-47fa-873d-9639197d1677",
  );
  let cycleCountModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "25db8bb0-ef56-4da4-ab28-434a1b0ca5e3",
  );
  let rejectionModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "a1d0642c-3a34-48e6-8812-339cf73772e0",
  );
  let unplannedIssueModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "ee49316f-987e-4829-bdfa-5bab0ddac593",
  );

  let inprogressModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "231cacd9-1781-4825-ab8a-a1b8997047cf",
  );
  let CreateMaterialRequestParentModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "2d83416d-d760-4139-b3bf-ccb7e0fc8d10",
  );

  let sfWarehouseModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "5778c75c-ec3a-48cb-8e57-a1d937dcd975",
  );
  let assemblyMasterModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "ace29e67-464f-44f2-ac70-a0f553d02328",
  );
  let stationItemMappingModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "5e4404d4-c1fe-4652-9ac9-19c9526e54ed",
  );
  let assemblyViewModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "9a962468-ade8-4c8a-8b87-b08ebc566966",
  );
  let bomModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "148cdc31-c98a-4cf0-8e77-5f8d63cd5f77",
  );
  let fgTransactionModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "a6d2c08b-a6da-494c-b552-0c6793d034bd",
  );
  let fgMasterModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "ff54b518-f888-4bbe-9961-76f8b398cea5",
  );

  let consumptionModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "b5947356-04fa-47e6-bef1-48d3b24c2df7",
    )
    : "";

  let workOrderModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "3950ac1f-4cdd-454c-a2d5-1163a782dec8",
  );

  let adminConrolModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "f36d9c3f-0e26-459d-b96d-ddafabba06fe",
  );

  let userManagementForAdminModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "9dc0e557-ab73-483f-963c-9cd6713535e8",
  );

  let moduleManagementModule = modulesData.find(
    (moduleId) =>
      moduleId.parentModuleId == "1b27aa80-813b-4112-9af3-e56e85caf672",
  );

  let warehouseOccupancyModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "6a523539-2422-4e1d-9e5f-3312b5244af2",
  );
  let wmsStockModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "9ff84c7e-8036-4e8c-9953-52dd66ae820a",
  );
  let itemStatusModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "1087705d-34b2-4328-9824-9b0a5b9a3aca",
  );
  let picklistAgeingModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "45716e24-cd73-4680-b525-9db71fa5ae2d",
  );
  let ageingReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "81ba9969-c951-4313-b495-c3cb236cf9f4",
  );
  let documentTurnAroundModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "dbc03a0c-4160-4b41-9303-6c20f97a3d53",
  );

  let tGrnReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "f6616f45-e5cb-4adb-a78a-a17374fd6ab1",
  );
  let transactionReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "1ecc075b-c824-4f05-9c1a-b7025eb5f047",
  );
  let rejectionReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "7502ad03-a573-472d-9c5e-f2c11f29c293",
  );
  let quarantineReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "ef3316fd-5ee8-4a73-a1df-68bc50f2c30f",
  );
  let picklistReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "0b5c91fc-9210-4b0f-bf2a-843989a42366",
  );
  let dispatchReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "da093a73-e9b0-4da7-9d40-5de7c174bc25",
  );
  let stockAvailalbleReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "151f9b48-0565-4eb0-a927-745a25b82018",
  );
  let consumptionReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "e79b8f77-2463-4d1a-815d-3900cbb75a45",
  );

  let bomMismatchReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "6ced8e32-6b68-4a72-96cc-39111aa633b8",
  );
  let fgRelatedReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "5a8a0252-1e84-48a7-a890-365f1b2ed28b",
  );

  let asnGrnDependencyModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "",
  );

  let minMaxFailureModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "",
  );

  let vendorPerformanceModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "",
  );

  let top10Module = modulesData.find(
    (moduleId) => moduleId.moduleId == "f925ea16-d94d-44e6-83ca-8ca0ba2840c0",
  );

  let calendarModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "5d72cda1-caa7-4643-a25c-8827affac6dc",
    )
    : "";

  let asnDetailsModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "fa4eecc7-2361-45af-8ebf-5350cdf56650",
    )
    : "";

  let circularModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "93953b81-e905-4311-ba8b-1a4a82a38705",
    )
    : "";

  let ocrModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "52870351-50f9-45a9-8415-3476f2387c95",
    )
    : "";

  // let circularModule =true
  let packagingModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "aef63a6e-dc40-4286-b0bc-407d630345b7",
    )
    : "";

  let userMachineModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "fe80932b-f005-4adc-9e50-88c0992f83c6",
    )
    : "";

  let MachineCenterModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "a9341614-e12f-43b6-8c69-2595ff3bf95b",
    )
    : "";

  let operationsModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "64e94e40-96b8-420f-8716-1d14205da211",
    )
    : "";

  let operationMachineMappingModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "f51df6e2-bfaa-48bd-88b7-13e106700ce7",
    )
    : "";

  let poModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "ede80aeb-d437-41d3-9df1-ea6e446f4019",
    )
    : "";

  let workCenterModule = modulesData
    ? modulesData.find(
      (moduleId) =>
        moduleId.parentModuleId == "034a34de-df03-4812-9875-e9b594b04e82",
    )
    : "";

  let woProcessLogReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "6aeea796-9313-473c-abf9-da038212f7f3",
  );

  let digitalPassportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "14087f18-c281-4ed7-9f1a-c1b627b50f8e",
  );

  let viewAccess = digitalPassportModule
    ? digitalPassportModule.actionId.includes(
      "878ad879-c8e7-4ff2-afbe-5db4c42eb239",
    )
    : null;

  let viewSystemAccess = digitalPassportModule
    ? digitalPassportModule.actionId.includes(
      "c5adf5a5-8c52-41f4-a5bd-43c0134785a5",
    )
    : null;
    
  let supplierInformationModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "f3746f89-be0f-4c4a-b175-ef969d0da2b0",
  );

  let manufacturerModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "d51e5caa-b714-4739-877a-3b78d6f9d263",
  );


  let industryMasterModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "2acc04c5-9639-456e-b72a-d399cc5674da",
  );


  let uploadErrorLogModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "4bc2750e-6095-402c-81fe-a22def5a18bf",
  );

  let roleName = loginDetails?.data?.roleName;

  const routes = [
    roleName !== "superadmin" && {
      type: "collapse",
      name: "Home",
      key: "home",
      icon: <Icon fontSize="small">home</Icon>,
      route: "/home",
      component: <Home />,
    },

    warehousesModule
      ? {
        type: "collapse",
        name: "Warehouses",
        key: "warehouses",
        icon: <Icon fontSize="small">store_outlined</Icon>,
        route: "/warehouses",
        component: <Warehouses />,
      }
      : "",

    viewAccess
      ? {
        type: "collapse",
        name: "DPP",
        key: "DPP",
        icon: <Icon fontSize="small">memory</Icon>,
        route: "/DPP",
        component: <DppLayout />,
      }
      : "",

    grnDetailsModule && roleName !== "superadmin"
      ? {
        type: "collapse",
        name: "GRN Details",
        key: "grn-details",
        icon: <Icon fontSize="small">summarize</Icon>,
        route: "/grn-details",
        component: <GrnDetails />,
      }
      : "",

    quarantineModule && roleName !== "superadmin"
      ? {
        type: "collapse",
        name: "Quarantine",
        key: "quarantine",
        icon: <Icon fontSize="small">factory</Icon>,
        route: "/quarantine",
        component: <Quarantine />,
      }
      : "",
    rejectionModule && roleName !== "superadmin"
      ? {
        type: "collapse",
        name: "Rejections",
        key: "rejections",
        icon: <Icon fontSize="small">do_not_disturb</Icon>,
        route: "/rejections",
        component: <Rejections />,
      }
      : "",
    // dispatchModule
    //   ? {
    //       type: "collapse",
    //       name: "Dispatch",
    //       key: "dispatch",
    //       icon: <Icon fontSize="small">local_shipping</Icon>,
    //       route: "/dispatch",
    //       component: <Dispatch />,
    //     }
    //   : "",
    transactionModule
      ? {
        type: "collapse",
        name: "Transaction",
        key: "transaction",
        icon: <Icon fontSize="small">request_quote</Icon>,
        route: "/transaction",
        component: <TransactionParent />,
      }
      : "",
    // cycleCountModule
    //   ? {
    //       type: "collapse",
    //       name: "Cycle Count",
    //       key: "cycle-count",
    //       icon: <Icon fontSize="small">assessment</Icon>,
    //       route: "/cycle-count",
    //       component: <CycleCount />,
    //     }
    //   : "",
    unplannedIssueModule
      ? {
        type: "collapse",
        name: "Unplanned Issue",
        key: "unplanned-issue",
        icon: <Icon fontSize="small">grading</Icon>,
        route: "/unplanned-issue",
        component: <UnplannedIssue />,
      }
      : "",
    // inprogressModule
    //   ? {
    //       type: "collapse",
    //       name: "Tickets",
    //       key: "tickets",
    //       icon: <Icon fontSize="small">content_paste</Icon>,
    //       route: "/tickets",
    //       component: <Tickets />,
    //     }
    //   : "",
    // // {
    // //   type: "collapse",
    // //   name: "Material Request",
    // //   key: "material-request",
    // //   icon: <Icon fontSize="small">summarize</Icon>,
    // //   route: "/material-request",
    // //   component: <MaterialRequest />,
    // // },
    // CreateMaterialRequestParentModule
    //   ? {
    //       type: "collapse",
    //       name: "Material Request",
    //       key: "material-request",
    //       icon: <Icon fontSize="small">create_new_folder</Icon>,
    //       route: "/material-request",
    //       component: <CreateMaterialRequestParent />,
    //     }
    //   : "",

    ...(sfWarehouseModule ||
      assemblyMasterModule ||
      stationItemMappingModule ||
      assemblyViewModule ||
      bomModule ||
      userMachineModule ||
      MachineCenterModule ||
      operationsModule ||
      operationMachineMappingModule ||
      poModule ||
      workCenterModule
      ? [
        {
          type: "expand",
          name: "Shop Floor",
          key: "Shop Floor",
          icon: <Icon fontSize="small">inventory</Icon>,
          subRoutes: [
            ...(sfWarehouseModule
              ? [
                {
                  type: "collapse",
                  name: "SF Warehouse",
                  key: "sf-warehouse",
                  icon: <Icon fontSize="small">factory</Icon>,
                  route: "/sf-warehouse",
                },
              ]
              : []),
            ...(operationsModule
              ? [
                {
                  type: "collapse",
                  name: "Operations",
                  key: "operations",
                  icon: <Icon fontSize="small">assessment</Icon>,
                  route: "/operations",
                },
              ]
              : []),
            ...(MachineCenterModule
              ? [
                {
                  type: "collapse",
                  name: "Machine Center",
                  key: "machine-center",
                  icon: <Icon fontSize="small">label</Icon>,
                  route: "/machine-center",
                },
              ]
              : []),
            ...(userMachineModule
              ? [
                {
                  type: "collapse",
                  name: "User Machine Map",
                  key: "userMachine-map",
                  icon: <Icon fontSize="small">gps_fixed</Icon>,
                  route: "/userMachine-map",
                },
              ]
              : []),

            ...(operationMachineMappingModule
              ? [
                {
                  type: "collapse",
                  name: "Operation Machine Map",
                  key: "operation-machine-map",
                  icon: <Icon fontSize="small">grading</Icon>,
                  route: "/operation-machine-map",
                },
              ]
              : []),
            ...(assemblyMasterModule
              ? [
                {
                  type: "collapse",
                  name: "Assembly Master",
                  key: "assembly-master",
                  icon: <Icon fontSize="small">maps_home_work</Icon>,
                  route: "/assembly-master",
                },
              ]
              : []),
            ...(stationItemMappingModule
              ? [
                {
                  type: "collapse",
                  name: "Station & Item Mapping",
                  key: "station-and-item-mapping",
                  icon: <Icon fontSize="small">grading</Icon>,
                  route: "/station-and-item-mapping",
                },
              ]
              : []),
            ...(assemblyViewModule
              ? [
                {
                  type: "collapse",
                  name: "Assembly View",
                  key: "assembly-view",
                  icon: <Icon fontSize="small">view_module</Icon>,
                  route: "/assembly-view",
                },
              ]
              : []),
            ...(bomModule
              ? [
                {
                  type: "collapse",
                  name: "BOM",
                  key: "bom",
                  icon: <Icon fontSize="small">format_list_numbered</Icon>,
                  route: "/bom",
                },
              ]
              : []),

            ...(workCenterModule
              ? [
                {
                  type: "collapse",
                  name: "Work Center",
                  key: "work-center",
                  icon: <Icon fontSize="small">group</Icon>,
                  route: "/work-center",
                },
              ]
              : []),
            ...(poModule
              ? [
                {
                  type: "collapse",
                  name: "WO Management",
                  key: "wo-management",
                  icon: <Icon fontSize="small">apartment</Icon>,
                  route: "/wo-management",
                },
              ]
              : []),
          ],
        },
      ]
      : []),

    // ...(sfWarehouseModule ||
    // assemblyMasterModule ||
    // stationItemMappingModule ||
    // assemblyViewModule ||
    // bomModule
    //   ? [
    //       {
    //         type: "expand",
    //         name: "Shop Floor",
    //         key: "Shop Floor",
    //         icon: <Icon fontSize="small">inventory</Icon>,
    //         subRoutes: [
    //           ...(sfWarehouseModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "SF Warehouse",
    //                   key: "sf-warehouse",
    //                   icon: <Icon fontSize="small">factory</Icon>,
    //                   route: "/sf-warehouse",
    //                 },
    //               ]
    //             : []),
    //           ...(assemblyMasterModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "Assembly Master",
    //                   key: "assembly-master",
    //                   icon: <Icon fontSize="small">maps_home_work</Icon>,
    //                   route: "/assembly-master",
    //                 },
    //               ]
    //             : []),
    //           ...(stationItemMappingModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "Station & Item Mapping",
    //                   key: "station-and-item-mapping",
    //                   icon: <Icon fontSize="small">grading</Icon>,
    //                   route: "/station-and-item-mapping",
    //                 },
    //               ]
    //             : []),
    //           ...(assemblyViewModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "Assembly View",
    //                   key: "assembly-view",
    //                   icon: <Icon fontSize="small">view_module</Icon>,
    //                   route: "/assembly-view",
    //                 },
    //               ]
    //             : []),
    //           ...(bomModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "BOM",
    //                   key: "bom",
    //                   icon: <Icon fontSize="small">format_list_numbered</Icon>,
    //                   route: "/bom",
    //                 },
    //               ]
    //             : []),
    //         ],
    //       },
    //     ]
    //   : []),
    ...(fgTransactionModule || fgMasterModule || workOrderModule
      ? [
        {
          type: "expand",
          name: "Finished Goods",
          key: "Finished Goods",
          icon: <Icon fontSize="small">move_to_inbox</Icon>,
          subRoutes: [
            ...(fgTransactionModule
              ? [
                {
                  type: "collapse",
                  name: "FG Transaction",
                  key: "fg-transaction",
                  icon: <Icon fontSize="small">all_inbox</Icon>,
                  route: "/fg-transaction",
                },
              ]
              : []),
            ...(fgMasterModule
              ? [
                {
                  type: "collapse",
                  name: "FG Master",
                  key: "fg-master",
                  icon: <Icon fontSize="small">location_searching</Icon>,
                  route: "/fg-master",
                },
              ]
              : []),
            ...(workOrderModule
              ? [
                {
                  type: "collapse",
                  name: "Work Order",
                  key: "work-order",
                  icon: <Icon fontSize="small">grading</Icon>,
                  route: "/work-order",
                },
              ]
              : []),
          ],
        },
      ]
      : []),

    // ...(fgMasterModule || workOrderModule
    //   ? [
    //       {
    //         type: "expand",
    //         name: "Finished Goods",
    //         key: "Finished Goods",
    //         icon: <Icon fontSize="small">move_to_inbox</Icon>,
    //         subRoutes: [
    //           // ...(fgTransactionModule
    //           //   ? [
    //           //       {
    //           //         type: "collapse",
    //           //         name: "FG Transaction",
    //           //         key: "fg-transaction",
    //           //         icon: <Icon fontSize="small">all_inbox</Icon>,
    //           //         route: "/fg-transaction",
    //           //       },
    //           //     ]
    //           //   : []),
    //           ...(fgMasterModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "FG Master",
    //                   key: "fg-master",
    //                   icon: <Icon fontSize="small">location_searching</Icon>,
    //                   route: "/fg-master",
    //                 },
    //               ]
    //             : []),
    //           ...(workOrderModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "Work Order",
    //                   key: "work-order",
    //                   icon: <Icon fontSize="small">grading</Icon>,
    //                   route: "/work-order",
    //                 },
    //               ]
    //             : []),
    //         ],
    //       },
    //     ]
    //   : []),
    dispatchModule
      ? {
        type: "collapse",
        name: "Dispatch",
        key: "dispatch",
        icon: <Icon fontSize="small">local_shipping</Icon>,
        route: "/dispatch",
        component: (
          <Suspense fallback={<div></div>}>
            <Dispatch />
          </Suspense>
        ),
      }
      : "",

    ...(itemMasterModule ||
      categoryCreationModule ||
      activityMovementModule ||
      assetMasterModule ||
      binMasterModule ||
      manufacturerModule ||
      supplierInformationModule
      ? [
        {
          type: "expand",
          name: "Master Setup",
          key: "master-setup",
          icon: <Icon fontSize="small">settings</Icon>,
          subRoutes: [
            ...(itemMasterModule
              ? [
                {
                  type: "collapse",
                  name: "Item Master",
                  key: "item-master",
                  icon: <Icon fontSize="small">description</Icon>,
                  route: "/item-master",
                },
              ]
              : []),
            ...(categoryCreationModule
              ? [
                {
                  type: "collapse",
                  name: "Category Creation",
                  key: "category-creation",
                  icon: <Icon fontSize="small">category</Icon>,
                  route: "/category-creation",
                },
              ]
              : []),

            ...(activityMovementModule
              ? [
                {
                  type: "collapse",
                  name: "Activity",
                  key: "activity",
                  icon: (
                    <Icon fontSize="small">production_quantity_limits</Icon>
                  ),
                  route: "/activity",
                },
              ]
              : []),
            ...(assetMasterModule
              ? [
                {
                  type: "collapse",
                  name: "AssetAudit",
                  key: "assetAudit",
                  icon: <Icon fontSize="small">gps_fixed</Icon>,
                  route: "/assetAudit",
                },
              ]
              : []),

            ...(assetMasterModule
              ? [
                {
                  type: "collapse",
                  name: "Asset Master",
                  key: "asset-master",
                  icon: <Icon fontSize="small">web_asset</Icon>,
                  route: "/asset-master",
                },
              ]
              : []),
            ...(binMasterModule
              ? [
                {
                  type: "collapse",
                  name: "Bin/Pallet",
                  key: "bin-pallet",
                  icon: <Icon fontSize="small">dvr</Icon>,
                  route: "/bin-pallet",
                },
              ]
              : []),
            ...(manufacturerModule
              ? [
                {
                  type: "collapse",
                  name: "Manufacturer",
                  key: "manufacturer",
                  icon: (
                    <Icon fontSize="small">precision_manufacturing</Icon>
                  ),
                  route: "/manufacturer",
                },
              ]
              : []),
            ...(supplierInformationModule
              ? [
                {
                  type: "collapse",
                  name: "Supplier Information",
                  key: "Supplier-Information",
                  icon: <Icon fontSize="small">business</Icon>,
                  route: "/Supplier-Information",
                },
              ]
              : []),
            ...(assetMasterModule
              ? [
                {
                  type: "collapse",
                  name: "Industry Master",
                  key: "Industry-Master",
                  icon: <Icon fontSize="small">factory</Icon>,
                  route: "/Industry-Master",
                },
              ]
              : []),
          ],
        },
      ]
      : []),

    ...(relationLocationModule || categoryItemModule || locationMappingModule
      ? [
        {
          type: "expand",
          name: "Warehouse Setup",
          key: "warehouse-setup",
          icon: <Icon fontSize="small">warehouse_icon</Icon>,
          subRoutes: [
            ...(relationLocationModule
              ? [
                {
                  type: "collapse",
                  name: "Relational Location",
                  key: "relation-location",
                  icon: <Icon fontSize="small">receipt</Icon>,
                  route: "/relation-location",
                },
              ]
              : []),
            ...(docTypeUserMappingModule
              ? [
                {
                  type: "collapse",
                  name: "DocType User Mapping",
                  key: "doctype-user-mapping",
                  icon: <Icon fontSize="small">u_turn_right</Icon>,
                  route: "/doctype-user-mapping",
                },
              ]
              : []),
            ...(categoryItemModule
              ? [
                {
                  type: "collapse",
                  name: "Category Item Mapping",
                  key: "category-item-mapping",
                  icon: <Icon fontSize="small">class</Icon>,
                  route: "/category-item-mapping",
                },
              ]
              : []),
            ...(locationMappingModule
              ? [
                {
                  type: "collapse",
                  name: "Location Mapping",
                  key: "location-mapping",
                  icon: <Icon fontSize="small">dvr</Icon>,
                  route: "/location-mapping",
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    ...(picklistTrackingModule || transferOrderModule
      ? [
        {
          type: "expand",
          name: "Movement",
          key: "movement",
          icon: <Icon fontSize="small">move_to_inbox</Icon>,
          subRoutes: [
            ...(picklistTrackingModule
              ? [
                {
                  type: "collapse",
                  name: "Picklist Tracking",
                  key: "picklist-tracking",
                  icon: <Icon fontSize="small">location_searching</Icon>,
                  route: "/picklist-tracking",
                },
              ]
              : []),
            ...(transferOrderModule
              ? [
                {
                  type: "collapse",
                  name: "Transfer Order",
                  key: "transfer-order",
                  icon: <Icon fontSize="small">format_list_numbered</Icon>,
                  route: "/transfer-order",
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    reprintNewModule
      ? {
        type: "collapse",
        name: "Reprint",
        key: "reprint",
        icon: <Icon fontSize="small">print</Icon>,
        route: "/reprint",
        component: (
          <Suspense fallback={<div></div>}>
            <ReprintParent />
          </Suspense>
        ),
      }
      : "",
    uploadErrorLogModule
      ? {
        type: "collapse",
        name: "Upload Error Log",
        key: "UploadErrorLog",
        icon: <Icon fontSize="small">error_outline</Icon>,
        route: "/UploadErrorLog",
        component: (
          <Suspense fallback={<div></div>}>
            <UploadErrorLog />
          </Suspense>
        ),
      }
      : "",

    // ...(locationMappingModule
    //       ? [
    //           {
    //             type: "collapse",
    //             name: "Location Mapping",
    //             key: "location-mapping",
    //             icon: <Icon fontSize="small">dvr</Icon>,
    //             route: "/location-mapping",
    //           },
    //         ]
    //       : []),
    viewSystemAccess
      ? {
        type: "collapse",
        name: "DPP-System",
        key: "DPP-System",
        icon: <Icon fontSize="small">supervisor_account';</Icon>,
        route: "/DPP-System",
        component: (
          <Suspense fallback={<div></div>}>
            <DbbSystemParent />
          </Suspense>
        ),
      }
      : "",
    ,
    // ...(locationMappingModule
    //       ? [
    //           {
    //             type: "collapse",
    //             name: "Location Mapping",
    //             key: "location-mapping",
    //             icon: <Icon fontSize="small">dvr</Icon>,
    //             route: "/location-mapping",
    //           },
    //         ]
    //       : []),
    // reprintNewModule

    //   ?
    // {
    //   type: "collapse",
    //   name: "DPP-System",
    //   key: "DPP-System",
    //   icon: <Icon fontSize="small">supervisor_account';</Icon>,
    //   route: "/DPP-System",
    //   component: (
    //     <Suspense fallback={<div></div>}>
    //       <DbbSystemParent />
    //     </Suspense>
    //   ),
    // },
    // : "",
    ocrModule
      ? {
        type: "collapse",
        name: "OCR",
        key: "ocr",
        icon: <Icon fontSize="small">document_scanner</Icon>,
        route: "/ocr",
        component: (
          <Suspense fallback={<div></div>}>
            <OCR />
          </Suspense>
        ),
      }
      : "",
    packagingModule
      ? {
        type: "collapse",
        name: "Packaging",
        key: "packaging-workflow-management",
        icon: <Icon fontSize="small">inventory2</Icon>,
        route: "/packaging-workflow-management",
        component: <PackagingWorkflowManagement />,
      }
      : "",
    newVendorRequest
      ? {
        type: "collapse",

        name: "New Supplier Request",
        key: "new-supplier-request",
        icon: <Icon fontSize="small">contacts_icon</Icon>,
        route: "/new-supplier-request",
        component: (
          <Suspense fallback={<div></div>}>
            <VendorDetails />
          </Suspense>
        ),
      }
      : "",
    statusModule
      ? {
        type: "collapse",

        name: "Registration Status",
        key: "status",
        icon: <Icon fontSize="small">donut_large_icon</Icon>,
        route: "/status",
        component: (
          <Suspense fallback={<div></div>}>
            <Status />
          </Suspense>
        ),
      }
      : "",

    registerVModule
      ? {
        type: "collapse",
        name: "Approved Suppliers",
        key: "registered-suppliers",
        icon: <Icon fontSize="small">assignment_turned_in_icon</Icon>,
        route: "/registered-suppliers",
        component: (
          <Suspense fallback={<div></div>}>
            <RegisteredVendors />
          </Suspense>
        ),
      }
      : "",

    rejectedVendorsModule
      ? {
        type: "collapse",

        name: "Rejected Suppliers",
        key: "rejected-suppliers",
        icon: <Icon fontSize="small">cancel_icon</Icon>,
        route: "/rejected-suppliers",
        component: (
          <Suspense fallback={<div></div>}>
            <RejectedVendors />
          </Suspense>
        ),
      }
      : "",

    vendorMasterModule
      ? {
        type: "collapse",

        name: "Vendor Master",
        key: "vendor-master",
        icon: <Icon fontSize="small">cancel_icon</Icon>,
        route: "/vendor-master",
        component: (
          <Suspense fallback={<div></div>}>
            <VendorMaster />
          </Suspense>
        ),
      }
      : "",

    vendorMaterialMappingModule
      ? {
        type: "collapse",
        name: "Vendor Material Mapping",
        key: "vendor-material-mapping",
        icon: <Icon fontSize="small">ballot</Icon>,
        route: "/vendor-material-mapping",
        component: (
          <Suspense fallback={<div></div>}>
            <VendorMaterialMappingMaster />
          </Suspense>
        ),
      }
      : "",

    calendarModule
      ? {
        type: "collapse",

        name: "Calendar",
        key: "calendar",
        icon: <Icon fontSize="small">calendar_month</Icon>,
        route: "/calendar",
        component: (
          <Suspense fallback={<div></div>}>
            <Calendar />
          </Suspense>
        ),
      }
      : "",

    circularModule
      ? {
        type: "collapse",

        name: "Circular",
        key: "circular",
        icon: <Icon fontSize="small">newspaper</Icon>,
        route: "/circular",
        component: (
          <Suspense fallback={<div></div>}>
            <Circular />
          </Suspense>
        ),
      }
      : "",

    downloadCenterModule
      ? {
        type: "collapse",

        name: "Document Download",
        key: "document-download-center",
        icon: <Icon fontSize="small">download</Icon>,
        route: "/document-download-center",
        component: (
          <Suspense fallback={<div></div>}>
            <DocumentDownloadCenter />
          </Suspense>
        ),
      }
      : "",

    newDemandModule
      ? {
        type: "collapse",
        name: "Demand",
        key: "demand",
        icon: <Icon fontSize="small">payment</Icon>,
        route: "/demand",
        component: <NewDemand />,
      }
      : "",
    asnDetailsModule
      ? {
        type: "collapse",
        name: "ASN details",
        key: "asn-details",
        icon: <Icon fontSize="small">account_box</Icon>,
        route: "/asn-details",
        component: <AsnDetails />,
      }
      : "",

    productionPlanModule
      ? {
        type: "collapse",
        name: "Production Plan",
        key: "production-plan",
        icon: <Icon fontSize="small">how_to_reg</Icon>,
        route: "/production-plan",
        component: <ProductionPlanParent />,
      }
      : "",

    vendorStockModule
      ? {
        type: "collapse",
        name: "Vendor Stock",
        key: "vendor-stock",
        icon: <Icon fontSize="small">format_list_bulleted</Icon>,
        route: "/vendor-stock",
        component: <VendorUpload />,
      }
      : "",

    purchaseOrderModule
      ? {
        type: "collapse",
        name: "Purchase Order",
        key: "purchase-order",
        icon: <Icon fontSize="small">request_quote</Icon>,
        route: "/purchase-order",
        component: <PurchaseOrders />,
      }
      : "",

    aiChatBotModule
      ? {
        type: "collapse",
        name: "MOBY",
        key: "ai-chat-bot",
        icon: (
          <img
            src={aiIcon}
            alt="Bot"
            style={{
              width: "25px",
              height: "auto",
              filter: "brightness(0) invert(1)",
            }}
          />
        ),
        route: "/ai-chat-bot",
        component: <AiChatBot />,
      }
      : "",

    invoiceModule
      ? {
        type: "collapse",
        name: "Invoice",
        key: "invoice",
        icon: <Icon fontSize="small">receipt_long</Icon>,
        route: "/invoice",
        component: <Invoice />,
      }
      : "",

    purchaseOrderOldModule
      ? {
        type: "collapse",
        name: "Purchase Order",
        key: "purchase-order-old",
        icon: <Icon fontSize="small">request_quote</Icon>,
        route: "/purchase-order-old",
        component: <PurchaseOrder />,
      }
      : "",
    acceptPOModule
      ? {
        type: "collapse",
        name: "Accept PO",
        key: "accept-po",
        icon: <Icon fontSize="small">account_tree</Icon>,
        route: "/accept-po",
        component: <AcceptPo />,
      }
      : "",
    // ...(demandModule ||
    // purchaseOrderModule ||
    // acceptPOModule ||
    // productionPlanModule ||
    // asnDetailsModule ||
    // vendorMaterialMappingModule
    //   ? [
    //       {
    //         type: "expand",
    //         name: "Supplier Portal",
    //         key: "Supplier-portal",
    //         icon: <Icon fontSize="small">format_list_bulleted_icon</Icon>,
    //         subRoutes: [
    //           ...(demandModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "Demand",
    //                   key: "demand",
    //                   icon: <Icon fontSize="small">payment</Icon>,
    //                   route: "/demand",
    //                 },
    //               ]
    //             : []),

    //           ...(acceptPOModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "Accept PO",
    //                   key: "accept-po",
    //                   icon: <Icon fontSize="small">account_tree</Icon>,
    //                   route: "/accept-po",
    //                 },
    //               ]
    //             : []),
    //           ...(productionPlanModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "Production Plan",
    //                   key: "production-plan",
    //                   icon: <Icon fontSize="small">how_to_reg</Icon>,
    //                   route: "/production-plan",
    //                 },
    //               ]
    //             : []),
    //           ...(asnDetailsModule
    //             ? [
    //                 {
    //                   type: "collapse",
    //                   name: "ASN details",
    //                   key: "asn-details",
    //                   icon: <Icon fontSize="small">account_box</Icon>,
    //                   route: "/asn-details",
    //                 },
    //               ]
    //             : []),

    //         ],
    //       },
    //     ]
    //   : []),
    ...(warehouseOccupancyModule ||
      wmsStockModule ||
      itemStatusModule ||
      picklistAgeingModule ||
      ageingReportModule ||
      documentTurnAroundModule ||
      woProcessLogReportModule
      ? [
        {
          type: "expand",
          name: "Reports",
          key: "reports",
          icon: <Icon fontSize="small">playlist_add</Icon>,
          subRoutes: [
            ...(warehouseOccupancyModule
              ? [
                {
                  type: "collapse",
                  name: "Warehouse Occupancy",
                  key: "warehouse-occupancy",
                  icon: (
                    <Icon fontSize="small">insert_drive_file_outlined</Icon>
                  ),
                  route: "/warehouse-occupancy",
                },
              ]
              : []),

            ...(tGrnReportModule
              ? [
                {
                  type: "collapse",
                  name: "GRN",
                  key: "GRN",
                  icon: <Icon fontSize="small">ballot</Icon>,
                  route: "/GRN",
                },
              ]
              : []),
            ...(transactionReportModule
              ? [
                {
                  type: "collapse",
                  name: "Transaction Report",
                  key: "transaction-report",
                  icon: <Icon fontSize="small">bathroom</Icon>,
                  route: "/transaction-report",
                },
              ]
              : []),
            ...(rejectionReportModule
              ? [
                {
                  type: "collapse",
                  name: "Rejection-report",
                  key: "rejection-report",
                  icon: <Icon fontSize="small">do_not_disturb</Icon>,
                  route: "/rejection-report",
                },
              ]
              : []),
            ...(quarantineReportModule
              ? [
                {
                  type: "collapse",
                  name: "Quarantine-report",
                  key: "quarantine-report",
                  icon: <Icon fontSize="small">factory</Icon>,
                  route: "/quarantine-report",
                },
              ]
              : []),
            ...(picklistReportModule
              ? [
                {
                  type: "collapse",
                  name: "Picklist",
                  key: "picklist",
                  icon: <Icon fontSize="small">location_searching</Icon>,
                  route: "/picklist",
                },
              ]
              : []),
            // ...(warehouseOccupancyModule
            //   ? [
            //       {
            //         type: "collapse",
            //         name: "TransferOrder",
            //         key: "transferOrder",
            //         icon: (
            //           <Icon fontSize="small">format_list_numbered</Icon>
            //         ),
            //         route: "/transferOrder",
            //       },
            //     ]
            //   : []),
            ...(dispatchReportModule
              ? [
                {
                  type: "collapse",
                  name: "Dispatch-report",
                  key: "dispatch-report",
                  icon: <Icon fontSize="small">local_shipping</Icon>,
                  route: "/dispatch-report",
                },
              ]
              : []),
            ...(wmsStockModule
              ? [
                {
                  type: "collapse",
                  name: "WMS Stock",
                  key: "wms-stock",
                  icon: <Icon fontSize="small">list_alt</Icon>,
                  route: "/wms-stock",
                },
              ]
              : []),

            ...(stockAvailalbleReportModule
              ? [
                {
                  type: "collapse",
                  name: "Stock Availability",
                  key: "stock-availability",
                  icon: <Icon fontSize="small">inventory2</Icon>,
                  route: "/stock-availability",
                },
              ]
              : []),
            ...(consumptionReportModule
              ? [
                {
                  type: "collapse",
                  name: "Consumption",
                  key: "consumption",
                  icon: <Icon fontSize="small">summarize</Icon>,
                  route: "/consumption",
                },
              ]
              : []),
            ...(bomMismatchReportModule
              ? [
                {
                  type: "collapse",
                  name: "BOM Mismatch",
                  key: "bom-mismatch",
                  icon: <Icon fontSize="small">category</Icon>,
                  route: "/bom-mismatch",
                },
              ]
              : []),

            // ],
            // : [])
            ...(itemStatusModule
              ? [
                {
                  type: "collapse",
                  name: "Item Status",
                  key: "item-status",
                  icon: <Icon fontSize="small">label</Icon>,
                  route: "/item-status",
                },
              ]
              : []),
            ...(picklistAgeingModule
              ? [
                {
                  type: "collapse",
                  name: "Picklist Ageing",
                  key: "picklist-ageing",
                  icon: (
                    <Icon fontSize="small">format_indent_decrease</Icon>
                  ),
                  route: "/picklist-ageing",
                },
              ]
              : []),
            ...(fgRelatedReportModule
              ? [
                {
                  type: "collapse",
                  name: "FG Related Report",
                  key: "fg-related-report",
                  icon: <Icon fontSize="small">assessment</Icon>,
                  route: "/fg-related-report",
                },
              ]
              : []),
            ...(ageingReportModule
              ? [
                {
                  type: "collapse",
                  name: "Ageing Report",
                  key: "ageing-report",
                  icon: <Icon fontSize="small">gps_fixed</Icon>,
                  route: "/ageing-report",
                },
              ]
              : []),
            ...(documentTurnAroundModule
              ? [
                {
                  type: "collapse",
                  name: "Doc Type TA Time",
                  key: "document-type-turn-around-time",
                  icon: <Icon fontSize="small">drive_file_move</Icon>,
                  route: "/document-type-turn-around-time",
                },
              ]
              : []),

            // ...(!asnGrnDependencyModule
            //   ? [
            //       {
            //         type: "collapse",
            //         name: "Asn Grn Dependency",
            //         key: "asn-grn-dependency",
            //         icon: <Icon fontSize="small">auto_graph</Icon>,
            //         route: "/asn-grn-dependency",
            //       },
            //     ]
            //   : []),

            ...(minMaxFailureModule
              ? [
                {
                  type: "collapse",
                  name: "Min Max Failure",
                  key: "min-max-failure",
                  icon: <Icon fontSize="small">trending_down</Icon>,
                  route: "/min-max-failure",
                },
              ]
              : []),

            // ...(!vendorPerformanceModule
            //   ? [
            //       {
            //         type: "collapse",
            //         name: "Vendor Performance",
            //         key: "vendor-performance",
            //         icon: <Icon fontSize="small">bar_chart</Icon>,
            //         route: "/vendor-performance",
            //       },
            //     ]
            //   : []),
            ...(top10Module
              ? [
                {
                  type: "collapse",
                  name: "Top 10",
                  key: "top-10",
                  icon: <Icon fontSize="small">align_vertical_top</Icon>,
                  route: "/top-10",
                },
              ]
              : []),
            ...(woProcessLogReportModule
              ? [
                {
                  type: "collapse",
                  name: "WO Process Log",
                  key: "wo-process-log-report",
                  icon: <Icon fontSize="small">web_stories</Icon>,
                  route: "/wo-process-log-report",
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    adminConrolModule
      ? {
        type: "collapse",
        name: "Admin Control",
        key: "admin-control",
        icon: <Icon fontSize="small">assessment</Icon>,
        route: "/admin-control",
        component: <NewAdminManagement />,
      }
      : "",

    roleName === "superadmin"
      ? ""
      : userManagementForAdminModule
        ? {
          type: "collapse",
          name: "User Management",
          key: "user-management",
          icon: <Icon fontSize="small">group</Icon>,
          route: "/user-management",
          component: <UserManagement />,
        }
        : "",
    moduleManagementModule
      ? {
        type: "collapse",
        name: "Module Management",
        key: "module-management",
        icon: <Icon fontSize="small">store_outlined</Icon>,
        route: "/module-management",
        component: <ModuleSubmoduleManagement />,
      }
      : "",

    {
      type: "collapse",
      name: "Logout",
      key: "logout",
      icon: <Icon fontSize="small">lock</Icon>,
      route: "/authentication/logout",
      component: <Logout />,
    },
  ];

  let forgotPasswordData = cookies.get("forgot-password-for-warehouse");
  let verificationData = cookies.get("vendor-portal-jwtToken");
  let token = loginDetails?.jwt;
  const isMyTokenExpired = isExpired(token);



  const isDppRoute = window.location.pathname.toLowerCase() === "/dpp";

  useEffect(() => {
    if ((!loginDetails || isMyTokenExpired) && isDppRoute) {
      localStorage.setItem(
        "intendedRoute",
        window.location.pathname + window.location.search,
      );
    }
  }, [loginDetails, isMyTokenExpired]);

  const initialEncodedPath = useRef(window.location.pathname);
  const [activePath, setActivePath] = React.useState("/home");

  const handleNavigate = (path) => {
    setActivePath(path);
  };

  let decodedRouteToRedirect = null;

  if (pathname.length > 1 && !pathname.toLowerCase().startsWith("/dpp")) {
    try {
      const possibleDecoded = atob(pathname.substring(1));
      if (possibleDecoded.toLowerCase().startsWith("/dpp")) {
        decodedRouteToRedirect = possibleDecoded;
      }
    } catch (error) { }
  }

  useEffect(() => {
    if (decodedRouteToRedirect) {
      localStorage.setItem("intendedRoute", decodedRouteToRedirect);
      navigate(decodedRouteToRedirect, { replace: true });
      setTimeout(() => {
        window.history.replaceState(null, "", pathname);
      }, 10);
    } else if (
      (!loginDetails || isMyTokenExpired) &&
      pathname.toLowerCase().startsWith("/dpp")
    ) {
      localStorage.setItem("intendedRoute", pathname + window.location.search);
    }
  }, [
    pathname,
    decodedRouteToRedirect,
    loginDetails,
    isMyTokenExpired,
    navigate,
  ]);

  useEffect(() => {
    if (decodedRouteToRedirect && initialEncodedPath.current) {
      window.history.replaceState(null, "", initialEncodedPath.current);
    }
  }, [location]);

  if (decodedRouteToRedirect) {
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: darkMode ? "#1a2035" : "#f0f2f5",
        }}
      ></div>
    );
  }


  if (loginDetails && !isMyTokenExpired) {
    if (loginDetails.status) {
      cookies.set("jwtForMobillorEditor", token, { path: "/" });
      return (
        <>
          <ThemeProvider theme={darkMode ? themeDark : theme}>
            <CssBaseline />
            {layout === "dashboard" && (
              <>
                <Sidenav
                  color={sidenavColor}
                  brand
                  routes={routes}
                  onMouseEnter={handleOnMouseEnter}
                  onMouseLeave={handleOnMouseLeave}
                />
                <Configurator />
                {configsButton}
              </>
            )}
            {layout === "vr" && <Configurator />}
            <Routes>
              {getRoutes(routes)}
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route
                exact
                path="/source-warehouse"
                element={<Warehouse />}
                key="source-warehouse"
              />
              <Route
                exact
                path="/delivery-warehouse"
                element={<DeliveryWarehouse />}
                key="delivery-warehouse"
              />
              <Route
                exact
                path="/manufacturer"
                element={<Manufacturer />}
                key="manufacturer"
              />

              <Route
                exact
                path="/supplier-Information"
                element={<SupplierInformation />}
                key="supplier-Information"
              />

              <Route
                exact
                path="/industry-Master"
                element={<IndustryMaster />}
                key="industry-Master"
              />

              <Route
                exact
                path="/fg-warehouse"
                element={<FgWarehouse />}
                key="fg-warehouse"
              />
              <Route exact path="/GRN" element={<GrnReport />} key="GRN" />

              <Route
                exact
                path="/rejection-report"
                element={<RejectionReport />}
                key="rejection-report"
              />
              <Route
                exact
                path="/quarantine-report"
                element={<QuarantineReport />}
                key="quarantine-report"
              />
              <Route
                exact
                path="/profile"
                element={<Profile />}
                key="profile"
              />
              <Route
                exact
                path="/banner-logo"
                element={<BannerLogo />}
                key="banner-logo"
              />
              <Route
                exact
                path="/:warehouseId"
                element={
                  (warehousesModule || sfWarehouseModule) && <ViewLocation />
                }
              />
              <Route
                exact
                path="/authentication/reset-password"
                element={<ResetPassword />}
                key="resetPassword"
              />

              <Route
                exact
                path="/printer-configurator"
                element={<PrinterConfigurator />}
                key="printer-configurator"
              />

              <Route
                exact
                path="/verification"
                element={<Navigate to="/home" />}
                key="verification"
              />

              <Route
                exact
                path="/standard-vendor-form"
                element={<Navigate to="/home" />}
                key="standard-vendor-form"
              />
              <Route
                exact
                path="/fg-master"
                element={<FgMaster />}
                key="fg-master"
              />
              <Route
                exact
                path="/assembly-master"
                element={
                  <Suspense fallback={<div></div>}>
                    <AssemblyMaster />
                  </Suspense>
                }
                key="assembly-master"
              />
              <Route
                exact
                path="/userMachine-map"
                element={
                  <Suspense fallback={<div></div>}>
                    <UserMachine />
                  </Suspense>
                }
                key="/userMachinemap"
              />
              <Route
                exact
                path="/machine-center"
                element={
                  <Suspense fallback={<div></div>}>
                    <MachineCenter />
                  </Suspense>
                }
                key="/machine-center"
              />
              <Route
                exact
                path="/operations"
                element={
                  <Suspense fallback={<div></div>}>
                    <Operations />
                  </Suspense>
                }
                key="/operations"
              />

              <Route
                exact
                path="/operation-machine-map"
                element={
                  <Suspense fallback={<div></div>}>
                    <OperationMachineMap />
                  </Suspense>
                }
                key="/operation-machine-map"
              />
              <Route
                exact
                path="/assembly-view"
                element={
                  <Suspense fallback={<div></div>}>
                    <AssemblyView />
                  </Suspense>
                }
                key="assembly-view"
              />
              <Route
                exact
                path="/sf-warehouse"
                element={
                  <Suspense fallback={<div></div>}>
                    <SfWarehouse />
                  </Suspense>
                }
                key="sf-warehouse"
              />
              <Route
                exact
                path="/station-and-item-mapping"
                element={
                  <Suspense fallback={<div></div>}>
                    <StationAndItemMapping />
                  </Suspense>
                }
                key="station and item mapping"
              />
              <Route
                exact
                path="/bom"
                element={
                  <Suspense fallback={<div></div>}>
                    <Bom />
                  </Suspense>
                }
                key="bom"
              />
              <Route
                exact
                path="/work-center"
                element={
                  <Suspense fallback={<div></div>}>
                    <ResourceGroupScreen />
                  </Suspense>
                }
                key="work-center"
              />
              <Route
                exact
                path="/wo-management"
                element={
                  <Suspense fallback={<div></div>}>
                    <PoManagement />
                  </Suspense>
                }
                key="wo-management"
              />
              <Route
                exact
                path="/work-order"
                element={
                  <Suspense fallback={<div></div>}>
                    <WorkOrder />
                  </Suspense>
                }
                key="work-order"
              />
              <Route
                exact
                path="/calendar"
                element={<Calendar />}
                key="calendar"
              />

              <Route
                exact
                path="/demand"
                element={<NewDemand />}
                key="demand"
              />
              <Route
                exact
                path="/circular"
                element={<Circular />}
                key="circular"
              />
              <Route
                exact
                path="/fg-transaction"
                element={<FinishedGoodsParent />}
                key="fg-transaction"
              />
              <Route
                exact
                path="/assembly-master"
                element={<AssemblyMaster />}
                key="assembly-master"
              />
              <Route
                exact
                path="/assembly-view"
                element={<AssemblyView />}
                key="assembly-view"
              />
              <Route
                exact
                path="/sf-warehouse"
                element={<SfWarehouse />}
                key="sf-warehouse"
              />
              <Route
                exact
                path="/station-and-item-mapping"
                element={<StationAndItemMapping />}
                key="station and item mapping"
              />
              <Route exact path="/bom" element={<Bom />} key="bom" />
              <Route
                exact
                path="/work-order"
                element={<WorkOrder />}
                key="work-order"
              />

              {/* <Route path="/" element={<WarehouseOccupancyDialog />} /> */}
              <Route
                path="/warehouse/:warehouseId"
                element={<WarehouseDetailsPage />}
              />

              <Route
                exact
                path="/status/:vendorUserId"
                element={<DashboardForm />}
                key="DashboardForm"
              />
              <Route
                exact
                path="/item-master"
                element={<ItemMasterParent />}
                key="item-master"
              />
              <Route
                exact
                path="/asn-details"
                element={<AsnDetails />}
                key="asn-details"
              />
              <Route
                exact
                path="/relation-location"
                element={<RelationLocation />}
                key="relation-location"
              />
              <Route
                exact
                path="/activity"
                element={<Activity />}
                key="activity"
              />
              <Route
                exact
                path="/category-item-mapping"
                element={<CategoryItemMapping />}
                key="category-item-mapping"
              />
              <Route
                exact
                path="/doctype-user-mapping"
                element={<DoctypeUserMapping />}
                key="doctype-user-mapping"
              />

              <Route
                exact
                path="/bin-pallet"
                element={<BinPalletMasters />}
                key="bin-pallet"
              />

              <Route
                exact
                path="/location-mapping"
                element={<LocationMapping />}
                key="location-mapping"
              />
              <Route
                exact
                path="/picklist"
                element={<PicklistTracking />}
                key="picklist"
              />
              <Route
                exact
                path="/asset-master"
                element={<AssetMaster />}
                key="asset-master"
              />
              <Route
                exact
                path="/category-creation"
                element={<CategoryCreationParent />}
                key="category-creation"
              />

              <Route
                exact
                path="/picklist-tracking"
                element={<Picklist />}
                key="picklist-tracking"
              />

              <Route
                exact
                path="/transfer-order"
                element={<TransferOrder />}
                key="transfer-order"
              />
              <Route
                exact
                path="/vendor-material-mapping"
                element={<VendorMaterialMappingMaster />}
                key="vendor-material-mapping"
              />
              {/* <Route
              exact
              path="/vandor-form"
              element={<VendorForm />}
              key="VendorForm"
            /> */}
              <Route
                exact
                path="/rejected-suppliers/:vendorUserId"
                element={<DashboardForm />}
                key="DashboardForm"
              />
              <Route
                exact
                path="/registered-suppliers/:vendorUserId"
                element={<DashboardForm />}
                key="DashboardForm"
              />

              <Route
                exact
                path="/purchase-order"
                element={<PurchaseOrders />}
                key="purchase-order"
              />
              <Route
                exact
                path="/purchase-order-old"
                element={<PurchaseOrder />}
                key="purchase-order-old"
              />
              <Route
                exact
                path="/accept-po"
                element={<AcceptPo />}
                key="accept"
              />
              <Route
                exact
                path="/production-plan"
                element={<ProductionPlan />}
                key="production-plan"
              />

              <Route
                exact
                path="/new-supplier-request"
                element={<VendorDetails />}
                key="new-supplier-request"
              />
              <Route exact path="/status" element={<Status />} key="status" />
              <Route
                exact
                path="/registered-suppliers"
                element={<RegisteredVendors />}
                key="registered-suppliers"
              />
              <Route
                exact
                path="/vendor-master"
                element={<VendorMaster />}
                key="vendor-master"
              />
              <Route
                exact
                path="/rejected-suppliers"
                element={<RejectedVendors />}
                key="rejected-suppliers"
              />
              <Route
                exact
                path="/warehouse-occupancy"
                element={<WarehouseOccupancy />}
                key="warehouse-occupancy"
              />
              <Route
                exact
                path="/wms-stock"
                element={<WmsStock />}
                key="wms-stock"
              />
              <Route
                exact
                path="/stock-availability"
                element={
                  <Suspense fallback={<div></div>}>
                    <StockAvailability />
                  </Suspense>
                }
                key="stock-availability"
              />
              <Route
                exact
                path="/bom-report"
                element={
                  <Suspense fallback={<div></div>}>
                    <BomReport />
                  </Suspense>
                }
                key="bom-report"
              />
              <Route
                exact
                path="/consumption"
                element={
                  <Suspense fallback={<div></div>}>
                    <Consumption />
                  </Suspense>
                }
                key="consumption"
              />
              <Route
                exact
                path="/picklist-ageing"
                element={
                  <Suspense fallback={<div></div>}>
                    <PicklistAgeing />
                  </Suspense>
                }
                key="picklist-ageing"
              />
              <Route
                exact
                path="/fg-related-report"
                element={
                  <Suspense fallback={<div></div>}>
                    <FgRelatedReport />
                  </Suspense>
                }
                key="fg-related-report"
              />
              <Route
                exact
                path="/document-type-turn-around-time"
                element={<DocumentTypeTurnAroundTime />}
                key="document-type-turn-around-time"
              />
              <Route
                exact
                path="/document-download-center"
                element={<DocumentDownloadCenter />}
                key="document-download-center"
              />
              <Route
                exact
                path="/subscription-plans"
                element={<PaymentPlans />}
                key="subscription-plans"
              />
              <Route
                exact
                path="/ai-agent-support"
                element={<AiAgent />}
                key="ai-agent-support"
              />
              <Route
                exact
                path="/checkout"
                element={<CheckoutPage />}
                key="checkout"
              />
              <Route
                exact
                path="/ageing-report"
                element={<AgeingReport />}
                key="ageing-report"
              />
              <Route
                exact
                path="/wo-process-log-report"
                element={<WoProcessLog />}
                key="wo-process-log-report"
              />
              <Route
                exact
                path="/asn-grn-dependency"
                element={<AsnGrnDependency />}
                key="asn-grn-dependency"
              />
              <Route
                exact
                path="/min-max-failure"
                element={<MinMaxFailure />}
                key="min-max-failure"
              />
              <Route
                exact
                path="/vendor-performance"
                element={<VendorPerformance />}
                key="vendor-performance"
              />
              <Route exact path="/top-10" element={<Top10 />} key="top-10" />
              <Route
                exact
                path="/item-status"
                element={<ItemStatus />}
                key="item-status"
              />
              <Route
                path="/authentication/logout"
                element={<Logout />}
                key="logout"
              />
            </Routes>
            <IdleTimerContainer />
          </ThemeProvider>
        </>
      );
    } else {
      return (
        <ThemeProvider theme={darkMode ? themeDark : theme}>
          <CssBaseline />
          <Routes>
            <Route
              path="/authentication/logout"
              element={<Logout />}
              key="logout"
            />
            {/* <Route
            path="/grn-details"
            element={<Navigate to="/authentication/logout" replace />}
            /> */}
          </Routes>
        </ThemeProvider>
      );
    }
  } else if (forgotPasswordData) {
    return (
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          <Route
            exact
            path="/set-new-password"
            element={<ForgotPassword />}
            key="set-new-password"
          />

          <Route exact path="/DPP" element={<DppLayout />} key="DPP-public" />
          <Route
            exact
            path="/dpp"
            element={<DppLayout />}
            key="dpp-public-small"
          />

          <Route exact path="/" element={<Login />} key="login" />
          <Route
            exact
            path="/register"
            element={<Registration />}
            key="register"
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ThemeProvider>
    );
  } else if (verificationData) {
    return (
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          <Route
            exact
            path="/verification"
            element={<Otp />}
            key="verification"
          />
          <Route
            exact
            path="/standard-vendor-form"
            element={<StandardVendorForm />}
            key="standard-vendor-form"
          />
          <Route
            exact
            path="/authentication/set-password"
            element={<SetPassword />}
            key="setPassword"
          />
          <Route
            exact
            path="/authentication/forgot-password/:email"
            element={<ForgotPassword />}
            key="forgotPassword"
          />

          <Route exact path="/DPP" element={<DppLayout />} key="DPP-public" />
          <Route
            exact
            path="/dpp"
            element={<DppLayout />}
            key="dpp-public-small"
          />
          <Route exact path="/" element={<Login />} key="login" />
          <Route
            exact
            path="/register"
            element={<Registration />}
            key="register"
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ThemeProvider>
    );
  } else {
    return (
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          <Route
            exact
            path="/verification"
            element={<Otp />}
            key="verification"
          />
          <Route
            exact
            path="/standard-vendor-form"
            element={<NoAccessPage />}
            key="standard-vendor-form"
          />

          <Route
            exact
            path="/authentication/set-password"
            element={<SetPassword />}
            key="setPassword"
          />
          <Route
            exact
            path="/authentication/forgot-password/:email"
            element={<ForgotPassword />}
            key="forgotPassword"
          />
          <Route exact path="/DPP" element={<DppLayout />} key="DPP-public" />
          <Route
            exact
            path="/dpp"
            element={<DppLayout />}
            key="dpp-public-small"
          />
          <Route exact path="/" element={<Login />} key="login" />
          <Route
            exact
            path="/register"
            element={<Registration />}
            key="register"
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ThemeProvider>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    // getModulesByRoleIdReducer: state.getModulesByRoleIdReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    // getModulesByRoleId: (roleId, jwtToken) =>
    //   dispatch(getModulesByRoleId(roleId, jwtToken)),
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(App);
